// // src/App.js

// import "./index.css";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { useEffect, useState } from "react";
// import { useIsAuthenticated, useMsal } from "@azure/msal-react";
// import { SSOSignin } from "./components/signin/SSOSignin";
// import { Layout } from "./components/constants/Layout";
// import { Timesheet } from "./components/modules/Timesheet";
// import { Teamtimesheet } from "./components/modules/Teamtimesheet";
// import { Employee } from "./components/modules/Settings/Employee";
// import { Project } from "./components/modules/Settings/Project";
// import { Client } from "./components/modules/Settings/Clients";
// import { Dashboard } from "./components/modules/Dashboard";
// import { Employee_report } from "./components/modules/Reports/Employee_report";
// import { MyWorkItems } from "./components/modules/MyWorkItems";
// import ProjectReports from "./components/modules/Reports/ProjectReport"
// import { setAxiosDefauls } from "./middleware/interceptor";
// import { Timesheetapi } from "./middleware/interceptor";
// import ClientAllocation from "./components/modules/Reports/ClientAllocation";
// import AWS from 'aws-sdk';
// import { LoginInfo } from "./components/Logins/LoginInfo";
// import { Task } from "./components/modules/Settings/Task";
// import ViewTicket from "./components/sections/ViewTicket";
// import { Approvals } from './components/modules/Settings/Approvals'
// import { Test } from './components/modules/Test'
// import PrivateRoute from './PrivateRoute'
// import TeamsActivities from "./components/modules/TeamsActivities";
// import Users from "./components/modules/Users";
// import Role from "./components/modules/Role";

// import { Utilization } from "./components/modules/Utilization";

// setAxiosDefauls();



// function App() {
//   const isAuthenticated = useIsAuthenticated();
//   const { instance } = useMsal();
//   const [Emp_Role, setEmp_Role] = useState()
//   const [employee_id, setEmployee_id] = useState();
//   const [Secret_key, setSecret_key] = useState("");
//   const [Key, setKey] = useState()
//   const [sidebor, setsidebor] = useState()


//   AWS.config.update({
//     accessKeyId: Key?.AwsAccess_Key,
//     secretAccessKey: Key?.AwsSecret_Key,
//     region: Key?.RegionName,
//   });

//   useEffect(() => {
//     const fetchData = async () => {
//       if (isAuthenticated) {
//         const { username } = instance?.getActiveAccount();
//         console.log("Email : ", username);

//         console.log(localStorage.getItem("bearer-token"), "bearer-token");

//         if (
//           localStorage.getItem("bearer-token") !== undefined &&
//           localStorage.getItem("bearer-token") !== null &&
//           isAuthenticated
//         ) {
//           console.log("Inside tok", localStorage.getItem("bearer-token"), username);

//           await getkey();
//           await getemployee(username);
//           await getSecretValue("TIMESHEET_KEYS");
//         }
//       }
//     };

//     fetchData();

//   }, [isAuthenticated, localStorage.getItem("bearer-token")]);

//   const getSecretValue = async (secretName) => {

//     const secretsManager = new AWS.SecretsManager();

//     try {
//       const data = await secretsManager.getSecretValue({ SecretId: secretName }).promise();

//       const secretkey = data.SecretString;
//       const parsedSecret = JSON.parse(secretkey);
//       const encryptionKey = parsedSecret.ENCRYPTION_KEY;
//       setSecret_key(encryptionKey);
//       console.log('Secret:', encryptionKey);



//     } catch (error) {
//       console.error('Error fetching secret:', error);
//     }


//   };
//   const getemployee = async (username) => {
//     try {
//       const response = await Timesheetapi.get(`api/Projects/getemployeebyid/${username}/`);
//       console.log("response", response.data.Employee[0].employee_id);

//       setEmp_Role(response?.data?.Employee[0]?.employee_role_id);
//       setEmployee_id(response?.data?.Employee[0]?.employee_id);

//       localStorage.setItem('employee_id', response?.data?.Employee[0]?.employee_id);
//       localStorage.setItem('emp_role_id', response?.data?.Employee[0]?.employee_role_id);
//       localStorage.setItem('role_name', response?.data?.Employee[0]?.employee_role_name);
//       localStorage.setItem('Emp_Assign_client', response?.data?.Employee[0]?.employee_client);
//       localStorage.setItem('Emp_Assign_project', response?.data?.Employee[0]?.employee_project);

//       console.log(response.data.Employee, "employee_id");
//     } catch (error) {
//       console.error("Error fetching employee data: ", error);
//     }
//   };
//   const getkey = async () => {
//     await Timesheetapi.get("api/Projects/getAwskey").then((Res) => {
//       setKey(Res?.data?.Key[0])
//     }).catch((err) => {
//       console.log("Error :", err)
//     })


//   }

//   return (
//     <BrowserRouter>
//       <Routes>
//         {/* Public login page */}
//         <Route
//           path="/"
//           element={
//             <SSOSignin
//               isAuthenticated={isAuthenticated}
//               setEmp_Role={setEmp_Role}
//               Emp_Role={Emp_Role}
//             />
//           }
//         />

//         {/* Protected Routes */}
//         <Route
//           path="/"
//           element={
//             <PrivateRoute>
//               <Layout isAuthenticated={isAuthenticated} setsidebor={setsidebor} />
//             </PrivateRoute>
//           }
//         >
//           {/* Common Routes */}
//           <Route path="timesheets" element={<Timesheet isAuthenticated={isAuthenticated} employee_id={employee_id} />} />
//           <Route path="my-workitems" element={<MyWorkItems />} />
//           <Route path="teams-activities" element={<TeamsActivities />} />
//           <Route path="users" element={<Users />} />
//           <Route path="role" element={<Role />} />

//           <Route path="/utilization" element={<Utilization />} />

//           {/* Role-Based Routes */}
//           {localStorage.getItem("emp_role_id") === "2" && (
//             <>
//              <Route path="dashboard" element={<Dashboard />} />

//               <Route path="Settings/Teamtimesheet" element={<Teamtimesheet isAuthenticated={isAuthenticated} employee_id={employee_id} />} />
//               <Route path="Settings/projects" element={<Project isAuthenticated={isAuthenticated} />} />
//               <Route path="Settings/employee" element={<Employee isAuthenticated={isAuthenticated} setEmployee_id={setEmployee_id} setEmp_Role={setEmp_Role} />} />
//               <Route path="Settings/clients" element={<Client />} />
//               <Route path="Approvals" element={<Approvals />} />
//               <Route path="Reports/client-report" element={<ClientAllocation Secret_key={Secret_key} sidebor={sidebor} />} />
//               <Route path="Reports/Employee_report" element={<Employee_report isAuthenticated={isAuthenticated} sidebo={sidebor} />} />
//               <Route path="reports" element={<ProjectReports sidebor={sidebor} />} />
//             </>
//           )}

//           {localStorage.getItem("emp_role_id") === "3" && (
//             <>
//               <Route path="dashboard" element={<Dashboard />} />
//               <Route path="Reports/client-report" element={<ClientAllocation Secret_key={Secret_key} sidebor={sidebor} />} />
//               <Route path="Reports/Employee_report" element={<Employee_report isAuthenticated={isAuthenticated} sidebo={sidebor} />} />
//               <Route path="reports" element={<ProjectReports sidebor={sidebor} />} />
//               <Route path="Settings/ticket" element={<Task />} />
//               <Route path="view-ticket/:clientId" element={<ViewTicket />} />
//               <Route path="Settings/projects" element={<Project isAuthenticated={isAuthenticated} />} />
//               <Route path="Settings/clients" element={<Client />} />

//               <Route path="Approvals" element={<Approvals />} />
//             </>
//           )}

//           {localStorage.getItem("emp_role_id") === "4" && (
//             <Route path="Logins/LoginInfo" element={<LoginInfo />} />
//           )}

//           {localStorage.getItem("emp_role_id") === "5" && (
//             <>
//               <Route path="Logins/LoginInfo" element={<LoginInfo />} />
//               <Route path="project-reports" element={<ProjectReports />} />
//             </>
//           )}

//           {localStorage.getItem("emp_role_id") === "6" && (
//             <>
//             <Route path="dashboard" element={<Dashboard />} />
//               <Route path="Reports/client-report" element={<ClientAllocation Secret_key={Secret_key} sidebor={sidebor} />} />
//               <Route path="Reports/Employee_report" element={<Employee_report isAuthenticated={isAuthenticated} sidebo={sidebor} />} />
//               <Route path="reports" element={<ProjectReports sidebor={sidebor} />} />
//               <Route path="Settings/projects" element={<Project isAuthenticated={isAuthenticated} />} />
//               <Route path="Settings/employee" element={<Employee isAuthenticated={isAuthenticated} setEmployee_id={setEmployee_id} setEmp_Role={setEmp_Role} />} />
//               <Route path="Settings/clients" element={<Client />} />
//               <Route path="Settings/ticket" element={<Task />} />
//               <Route path="view-ticket/:clientId" element={<ViewTicket />} />
//             </>
//           )}
//         </Route>

//       </Routes>


//     </BrowserRouter >
//   );
// }

// export default App;



// src/App.js

import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { SSOSignin } from "./components/signin/SSOSignin";
import { Layout } from "./components/constants/Layout";
import { Timesheet } from "./components/modules/Timesheet";
import { Teamtimesheet } from "./components/modules/Teamtimesheet";
import { Employee } from "./components/modules/Settings/Employee";
import { Project } from "./components/modules/Settings/Project";
import { Client } from "./components/modules/Settings/Clients";
import { Dashboard } from "./components/modules/Dashboard";
import { Employee_report } from "./components/modules/Reports/Employee_report";
import { MyWorkItems } from "./components/modules/MyWorkItems";
import ProjectReports from "./components/modules/Reports/ProjectReport"
import { setAxiosDefauls } from "./middleware/interceptor";
import { Timesheetapi } from "./middleware/interceptor";
import ClientAllocation from "./components/modules/Reports/ClientAllocation";
import AWS from 'aws-sdk';
import { LoginInfo } from "./components/Logins/LoginInfo";
import { Task } from "./components/modules/Settings/Task";
import ViewTicket from "./components/sections/ViewTicket";
import { Approvals } from './components/modules/Settings/Approvals'
import { Test } from './components/modules/Test'
import PrivateRoute from './PrivateRoute'
import TeamsActivities from "./components/modules/TeamsActivities";
import Users from "./components/modules/Users";
import Role from "./components/modules/Role";

import { Utilization } from "./components/modules/Utilization";

setAxiosDefauls();



function App() {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const [Emp_Role, setEmp_Role] = useState()
  const [employee_id, setEmployee_id] = useState();
  const [Secret_key, setSecret_key] = useState("");
  const [Key, setKey] = useState()
  const [sidebor, setsidebor] = useState()


  AWS.config.update({
    accessKeyId: Key?.AwsAccess_Key,
    secretAccessKey: Key?.AwsSecret_Key,
    region: Key?.RegionName,
  });

  useEffect(() => {
    const fetchData = async () => {
      if (isAuthenticated) {
        const { username } = instance?.getActiveAccount();
        console.log("Email : ", username);

        console.log(localStorage.getItem("bearer-token"), "bearer-token");

        if (
          localStorage.getItem("bearer-token") !== undefined &&
          localStorage.getItem("bearer-token") !== null &&
          isAuthenticated
        ) {
          console.log("Inside tok", localStorage.getItem("bearer-token"), username);

          await getkey();
          await getemployee(username);
          await getSecretValue("TIMESHEET_KEYS");
        }
      }
    };

    fetchData();

  }, [isAuthenticated, localStorage.getItem("bearer-token")]);

  const getSecretValue = async (secretName) => {

    const secretsManager = new AWS.SecretsManager();

    try {
      const data = await secretsManager.getSecretValue({ SecretId: secretName }).promise();

      const secretkey = data.SecretString;
      const parsedSecret = JSON.parse(secretkey);
      const encryptionKey = parsedSecret.ENCRYPTION_KEY;
      setSecret_key(encryptionKey);
      console.log('Secret:', encryptionKey);



    } catch (error) {
      console.error('Error fetching secret:', error);
    }


  };
  const getemployee = async (username) => {
    try {
      const response = await Timesheetapi.get(`api/Projects/getemployeebyid/${username}/`);
      console.log("response", response.data.Employee[0].employee_id);

      setEmp_Role(response?.data?.Employee[0]?.employee_role_id);
      setEmployee_id(response?.data?.Employee[0]?.employee_id);

      localStorage.setItem('employee_id', response?.data?.Employee[0]?.employee_id);
      localStorage.setItem('emp_role_id', response?.data?.Employee[0]?.employee_role_id);
      localStorage.setItem('role_name', response?.data?.Employee[0]?.employee_role_name);
      localStorage.setItem('Emp_Assign_client', response?.data?.Employee[0]?.employee_client);
      localStorage.setItem('Emp_Assign_project', response?.data?.Employee[0]?.employee_project);

      console.log(response.data.Employee, "employee_id");
    } catch (error) {
      console.error("Error fetching employee data: ", error);
    }
  };
  const getkey = async () => {
    await Timesheetapi.get("api/Projects/getAwskey").then((Res) => {
      setKey(Res?.data?.Key[0])
    }).catch((err) => {
      console.log("Error :", err)
    })


  }

  return (
    <BrowserRouter>
      <Routes>
        {/* Public login page */}
        <Route
          path="/"
          element={
            <SSOSignin
              isAuthenticated={isAuthenticated}
              setEmp_Role={setEmp_Role}
              Emp_Role={Emp_Role}
            />
          }
        />

        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout isAuthenticated={isAuthenticated} setsidebor={setsidebor} />
            </PrivateRoute>
          }
        >
          {/* Common Routes — every role */}
          {/* CHANGED: Dashboard is now common. Before, it was only defined for roles 2, 3 and 6,
              so roles 1 (Team Member), 4 (HR) and 5 (Accountant) got a blank page. */}
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="timesheets" element={<Timesheet isAuthenticated={isAuthenticated} employee_id={employee_id} />} />
          <Route path="my-workitems" element={<MyWorkItems />} />
          <Route path="teams-activities" element={<TeamsActivities />} />
          <Route path="users" element={<Users />} />
          <Route path="role" element={<Role />} />
          {/* Reached from Admin view; the API also limits data to what each role may see */}
          <Route path="utilization" element={<Utilization />} />

          {/* Role-Based Routes */}
          {localStorage.getItem("emp_role_id") === "2" && (
            <>
              <Route path="Settings/Teamtimesheet" element={<Teamtimesheet isAuthenticated={isAuthenticated} employee_id={employee_id} />} />
              <Route path="Settings/projects" element={<Project isAuthenticated={isAuthenticated} />} />
              <Route path="Settings/employee" element={<Employee isAuthenticated={isAuthenticated} setEmployee_id={setEmployee_id} setEmp_Role={setEmp_Role} />} />
              <Route path="Settings/clients" element={<Client />} />
              <Route path="Approvals" element={<Approvals />} />
              <Route path="Reports/client-report" element={<ClientAllocation Secret_key={Secret_key} sidebor={sidebor} />} />
              <Route path="Reports/Employee_report" element={<Employee_report isAuthenticated={isAuthenticated} sidebo={sidebor} />} />
              <Route path="reports" element={<ProjectReports sidebor={sidebor} />} />
            </>
          )}

          {localStorage.getItem("emp_role_id") === "3" && (
            <>
              <Route path="Reports/client-report" element={<ClientAllocation Secret_key={Secret_key} sidebor={sidebor} />} />
              <Route path="Reports/Employee_report" element={<Employee_report isAuthenticated={isAuthenticated} sidebo={sidebor} />} />
              <Route path="reports" element={<ProjectReports sidebor={sidebor} />} />
              <Route path="Settings/ticket" element={<Task />} />
              <Route path="view-ticket/:clientId" element={<ViewTicket />} />
              <Route path="Settings/projects" element={<Project isAuthenticated={isAuthenticated} />} />
              <Route path="Settings/clients" element={<Client />} />

              <Route path="Approvals" element={<Approvals />} />
            </>
          )}

          {localStorage.getItem("emp_role_id") === "4" && (
            <Route path="Logins/LoginInfo" element={<LoginInfo />} />
          )}

          {localStorage.getItem("emp_role_id") === "5" && (
            <>
              <Route path="Logins/LoginInfo" element={<LoginInfo />} />
              <Route path="project-reports" element={<ProjectReports />} />
            </>
          )}

          {localStorage.getItem("emp_role_id") === "6" && (
            <>
              <Route path="Reports/client-report" element={<ClientAllocation Secret_key={Secret_key} sidebor={sidebor} />} />
              <Route path="Reports/Employee_report" element={<Employee_report isAuthenticated={isAuthenticated} sidebo={sidebor} />} />
              <Route path="reports" element={<ProjectReports sidebor={sidebor} />} />
              <Route path="Settings/projects" element={<Project isAuthenticated={isAuthenticated} />} />
              <Route path="Settings/employee" element={<Employee isAuthenticated={isAuthenticated} setEmployee_id={setEmployee_id} setEmp_Role={setEmp_Role} />} />
              <Route path="Settings/clients" element={<Client />} />
              <Route path="Settings/ticket" element={<Task />} />
              <Route path="view-ticket/:clientId" element={<ViewTicket />} />
            </>
          )}
        </Route>

      </Routes>


    </BrowserRouter >
  );
}

export default App;